"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDescriptionComponent = exports.createDescription = void 0;
var react_1 = __importDefault(require("react"));
var DescriptionComponent_1 = __importDefault(require("../ItemComponents/DescriptionComponent"));
var createDescription = function (usingFeature, di, itemAdapter, itemStore, Editor, createUi, useEditorControls) {
    if (useEditorControls) {
        return di.convoke(exports.createDescriptionComponent, null, {
            isEditable: useEditorControls,
            model: itemStore.descriptionModel,
            configurationName: "quoteLineItem",
            contentString: "",
            itemStore: itemStore,
        });
    }
    else {
        return di.convoke(exports.createDescriptionComponent, null, {
            isEditable: useEditorControls,
            model: itemStore.descriptionModel,
            configurationName: "quoteLineItem",
            contentString: itemAdapter.description(),
            itemStore: itemStore,
        });
    }
};
exports.createDescription = createDescription;
var createDescriptionComponent = function (mountReactComponent, isEditable, di, contentString) {
    return mountReactComponent(react_1.default.createElement(DescriptionComponent_1.default, { useEditorControls: isEditable, di: di, contentString: contentString }));
};
exports.createDescriptionComponent = createDescriptionComponent;
